import React, { createContext, useEffect, useState } from 'react';
import { useSearchParams } from '@hummingbirdtechgroup/wings-router';
import UnitSystem from './constants/UnitSystem';
const LOCAL_STORAGE_KEY = 'unit-system';
const VALID_UNIT_SYSTEMS = [UnitSystem.METRIC, UnitSystem.IMPERIAL_US];
export const UnitSystemContext = createContext(UnitSystem.METRIC);
const getDefaultUnitSystem = () => {
    const value = localStorage.getItem(LOCAL_STORAGE_KEY);
    // @ts-ignore
    return !!value && VALID_UNIT_SYSTEMS.includes(value)
        ? value
        : UnitSystem.METRIC;
};
const UnitConversionProvider = ({ children }) => {
    const [unitSystem, setUnitSystem] = useState(getDefaultUnitSystem());
    const [searchParams] = useSearchParams();
    useEffect(() => {
        const { unitSystem: newUnitSystem } = searchParams;
        if (unitSystem && VALID_UNIT_SYSTEMS.includes(newUnitSystem)) {
            setUnitSystem(newUnitSystem);
            localStorage.setItem(LOCAL_STORAGE_KEY, newUnitSystem);
        }
    }, [searchParams]);
    return (React.createElement(UnitSystemContext.Provider, { value: unitSystem }, children));
};
export default UnitConversionProvider;
//# sourceMappingURL=UnitConversionProvider.js.map